// Tiny UUID v4 generator. We need a clientId for every sale confirmation for
// idempotency, so the client generates one locally and includes it in the
// POST. We don't pull in a uuid lib for this; crypto.randomUUID is standard.

export function uuid(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  // Fallback (shouldn't be needed in modern browsers/Node)
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
